import { useLocation } from "react-router";
import { faMagnifyingGlass } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Center, Stack, Text, Title } from "@mantine/core";

export const EditorQueryConsoleLoggedOut = () => {
  const location = useLocation();

  return (
    <Center mx="xl" h="100%">
      <Stack align="center">
        <FontAwesomeIcon
          icon={faMagnifyingGlass}
          size="6x"
          color="var(--mantine-color-blue-1)"
        />
        <Title order={2} ta="center">
          Search across your GitHub repositories
        </Title>
        <Text c="dimmed" mx="xl" ta="center">
          Take rule editing to the next level by viewing findings for a rule
          from any of your GitHub repositories. Sign in to get started.
        </Text>
        <Button component="a" href={`/login?return_path=${location.pathname}`}>
          Sign in
        </Button>
      </Stack>
    </Center>
  );
};
